export const dataGridWrapTextStyles = {
  '& .wrap-text': {
    whiteSpace: "normal !important",
    wordBreak: "break-word !important",
    overflowWrap: "break-word !important",
    lineHeight: "1.3 !important",
    display: "block !important",
    paddingTop: "8px",
    paddingBottom: "8px",
  },

  '& .MuiDataGrid-cell': {
    whiteSpace: "normal !important",
    alignItems: "flex-start !important",
    display: "flex !important",
    maxHeight: "none !important",
    overflow: "visible !important",
  },

  '& .MuiDataGrid-cellContent': {
    whiteSpace: "normal !important",
    overflow: "visible !important",
    textOverflow: "clip !important",
  },

  '& .MuiDataGrid-row': {
    maxHeight: "none !important",
  },
};
